import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import {
    Button,
    Dialog,
    Grid,
    FormControl,
    Theme
} from "@mui/material";
import { useSelector } from "react-redux";
import AlertConfirmDialog from "@/Components/ConfirmationModal/AlertConfirmDialog";
import { useAppDispatch } from "@/Redux/Redux";
import { getLocale } from "@/Redux/App/AppReducer";
import { useDisplayMessage } from "@/Utils/CustomHooks/useDisplayMessage";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";


interface LoginClientVersionErrorPopupProps {
    serverVersionPopupIsOpen: any;
    setServerVersionPopupIsOpen: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        width: 200,
        paddingBottom: 15,
    },

    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    submit: {
        margin: theme.spacing(0, 0, 2),
    },
    buttonProgress: {
        position: "absolute",
        top: "33%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        marginTop: theme.spacing(1),
        position: "relative",
    },

    error: {
        color: theme.palette.error.main,
    },
}));


const LoginClientVersionErrorPopup: FunctionComponent<LoginClientVersionErrorPopupProps> = (
{
    setServerVersionPopupIsOpen, 
    serverVersionPopupIsOpen
}): JSX.Element => {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const language = useSelector((state) => getLocale())
    const { t } = useTranslation();

    return <Dialog
        open={serverVersionPopupIsOpen}

    >
        <AlertConfirmDialog
            headline={t("login.messages.versionNotValid")}
            textContent={t("login.messages.makeSureVersion")}

        />
        <Grid container spacing={1}
            direction="column"
            alignItems="center"
            justifyContent="center">
            <Grid item xs={12}>
                <FormControl
                    variant="outlined"
                    margin={"dense"}
                    size={"small"}
                >
                    <Button
                        size={"small"}
                        variant={"outlined"}
                        onClick={() => {

                            setServerVersionPopupIsOpen(false)
                        }}

                    >
                        {t("login.buttonOkay")}

                    </Button>
                </FormControl>
            </Grid>
        </Grid>
    </Dialog>
}
export default LoginClientVersionErrorPopup;